import React from "react";

// Small colored pill used for status/category tags and change indicators.
export default function TspBadge({ children, tone = "neutral", className = "" }) {
  return <span className={`tsp-badge tsp-tone-${tone} ${className}`}>{children}</span>;
}
